import * as yup from 'yup'
import { metadata } from '../../config'
import { TPayDirectFormYupKeys } from '../../interfaces/payDetails'

const ValidationSchema = yup.object<TPayDirectFormYupKeys>({
  office: yup.object().required(metadata.office.required).nullable(),
  itemType: yup.object().required(metadata.itemType.required).nullable(),

  // itemType: yup.object().required(metadata.itemType.required).nullable(),
  amount: yup.number().required(metadata.amount.required).nullable(),
  itemList: yup.object({
    desc1: yup.string().required(metadata.desc.required).max(90, metadata.desc.max).nullable(),
    desc2: yup.string().max(90, metadata.desc.max),
    desc3: yup.string().max(90, metadata.desc.max),
    desc4: yup.string().max(90, metadata.desc.max),
    desc5: yup.string().max(90, metadata.desc.max),
    desc6: yup.string().max(90, metadata.desc.max),
  }),
  id: yup.string().notRequired(),
  list: yup.object({}).notRequired(),
})

export default ValidationSchema
